var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","multiple":"","name":_vm.uploadFieldName,"accept":"image/*","id":"input-file"},domProps:{"value":_vm.fileUpload},on:{"change":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }